import React from 'react'

function Coin() {
    return (
        <>
            {/* Coin area Start */}
            <section className="rts-coin-area rts-section-gap bg-four">
                <div className="container">
                    <div className="section-title-area2">
                        <p
                            className="sub-title wow fadeInUp"
                            data-wow-delay=".2s"
                            data-wow-duration="2s"
                        >
                            Get it Now On
                        </p>
                        <h2
                            className="section-title wow fadeInUp"
                            data-wow-delay=".5s"
                            data-wow-duration="2s"
                        >
                            Browse Trending Coin{" "}
                        </h2>
                    </div>
                    <div className="coin-list-inner mt--50">
                        <ul>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".2s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/bit-coin.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".3s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/ethereum.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".4s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/binance.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".5s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/solana.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".6s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/tether.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".7s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/xrp.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".8s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/dogecoin.svg" alt="" />
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".9s"
                                data-wow-duration="1.5s"
                            >
                                <img src="assets/images/token/solana-2.svg" alt="" />
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="shape-area">
                    <img src="assets/images/token/bg-shape-01.svg" alt="" />
                    <img src="assets/images/token/bg-shape-02.svg" alt="" />
                    <img
                        className="wow fadeInLeft"
                        data-wow-delay=".8s"
                        data-wow-duration="2s"
                        src="assets/images/token/image-02.svg"
                        alt=""
                    />
                    <img src="assets/images/token/coin-03.svg" alt="" />
                    <img src="assets/images/token/coin-03.svg" width={66} alt="" />
                    <img src="assets/images/token/coin-03.svg" width={50} alt="" />
                </div>
            </section>
            {/* Coin area end */}
        </>

    )
}

export default Coin